import React from 'react';
import { useState, useCallback } from 'react';
import { StaticImage } from 'gatsby-plugin-image'

import { Link, FormattedMessage } from 'gatsby-plugin-intl'

import cx from 'classnames'

import {
  nav_section,
  nav_open,
  nav_controls,
  active_nav_link,
} from '../layouts/styles.module.css'

import { usePopoverIsOpen } from '../components/popover'
import LangSelector from '../components/lang-selector'

const logo = '../images/kemene_consulting.png'

type Props = { index?: boolean }

type MenuState = boolean

const Nav = (_: Props): React.ReactNode => {

  const [menuState, setMenuState] = useState<MenuState>(false);

  const closeMenu = () => setMenuState(false);

  const toggleMenu = useCallback(() => setMenuState(s => !s), [setMenuState, menuState])


  const anyPopoverOpen = usePopoverIsOpen();

  return (
    <section className={cx({ [nav_section]: true, [nav_open]: menuState })}>
      <nav>
        <Link to='/'>
          <StaticImage objectFit='contain' height={60} loading='eager' alt='KEMENÉ' src={logo} />
        </Link>


        <div>
          <div className={cx(nav_controls)}>
            <button onClick={toggleMenu} key='nav-open-button-nav' disabled={anyPopoverOpen}>{menuState ? '✕' : '☰'}</button>
          </div>
          <ul key='nav-menu'>
            <li><Link onClick={closeMenu} activeClassName={active_nav_link} to='/'>
              <FormattedMessage id='common.pages.home' />
            </Link></li>
            <li><Link onClick={closeMenu} activeClassName={active_nav_link} to='/services'>
              <FormattedMessage id='common.pages.services' />
            </Link></li>
            <li><Link onClick={closeMenu} activeClassName={active_nav_link} to='/case-studies'>
              <FormattedMessage id='common.pages.case-studies' />
            </Link></li>
            <li><Link onClick={closeMenu} activeClassName={active_nav_link} to='/contact-us'>
              <FormattedMessage id='common.pages.contact-us' />
            </Link></li>
          </ul>

          <LangSelector text onSelect={closeMenu} />

        </div>

      </nav>
    </section >
  )
}

export default Nav
